// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OfficeRouteImport } from './routes/_office'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as SiteCoworldRouteImport } from './routes/_site.$coworld'
import { Route as SiteAccountRouteImport } from './routes/_site.account'
import { Route as SiteBrowseRouteImport } from './routes/_site.browse'
import { Route as SiteCompleteProfileRouteImport } from './routes/_site.complete-profile'
import { Route as SiteCoworldsRouteImport } from './routes/_site.coworlds'
import { Route as SiteGetStartedRouteImport } from './routes/_site.get-started'
import { Route as SitePoliciesRouteImport } from './routes/_site.policies'
import { Route as SiteSearchRouteImport } from './routes/_site.search'
import { Route as SiteSignInRouteImport } from './routes/_site.sign-in'
import { Route as SiteWatchRouteImport } from './routes/_site.watch'
import { Route as WorkspaceIdeNextRouteImport } from './routes/_workspace.ide-next'
import { Route as SiteCoworldIndexRouteImport } from './routes/_site.$coworld.index'
import { Route as SiteCoworldLeagueRouteImport } from './routes/_site.$coworld.$league'
import { Route as SiteCoworldDeskRouteImport } from './routes/_site.$coworld.desk'
import { Route as SiteCoworldPlayRouteImport } from './routes/_site.$coworld.play'
import { Route as SiteCoworldPreviewRouteImport } from './routes/_site.$coworld.preview'
import { Route as SiteCoworldSearchRouteImport } from './routes/_site.$coworld.search'
import { Route as SiteCoworldStartRouteImport } from './routes/_site.$coworld.start'
import { Route as SiteCoworldSubmitRouteImport } from './routes/_site.$coworld.submit'
import { Route as SiteAccountIndexRouteImport } from './routes/_site.account.index'
import { Route as SiteAccountAdvancedRouteImport } from './routes/_site.account.advanced'
import { Route as SiteAccountCredentialsRouteImport } from './routes/_site.account.credentials'
import { Route as SiteCliAuthIndexRouteImport } from './routes/_site.cli-auth.index'
import { Route as SiteCliAuthCompleteRouteImport } from './routes/_site.cli-auth.complete'
import { Route as SiteCoworldsIndexRouteImport } from './routes/_site.coworlds.index'
import { Route as SiteEpisodesEpisodeIdRouteImport } from './routes/_site.episodes.$episodeId'
import { Route as SiteExperienceRequestsRequestIdRouteImport } from './routes/_site.experience-requests.$requestId'
import { Route as SiteForumIndexRouteImport } from './routes/_site.forum.index'
import { Route as SiteForumPostIdRouteImport } from './routes/_site.forum.$postId'
import { Route as SiteGithubConnectRouteImport } from './routes/_site.github.connect'
import { Route as SiteLobbiesLobbyIdRouteImport } from './routes/_site.lobbies.$lobbyId'
import { Route as SitePlaySessionsSessionIdRouteImport } from './routes/_site.play-sessions.$sessionId'
import { Route as SitePlayIndexRouteImport } from './routes/_site.play.index'
import { Route as SitePlaySplatRouteImport } from './routes/_site.play_.$'
import { Route as SitePlayersPlayerIdRouteImport } from './routes/_site.players.$playerId'
import { Route as SitePoliciesIndexRouteImport } from './routes/_site.policies.index'
import { Route as SitePoliciesPolicyIdRouteImport } from './routes/_site.policies.$policyId'
import { Route as SitePreviewSplatRouteImport } from './routes/_site.preview.$'
import { Route as SiteReplaysCoworldIdRouteImport } from './routes/_site.replays.$coworldId'
import { Route as SiteTournamentsTournamentIdRouteImport } from './routes/_site.tournaments.$tournamentId'
import { Route as SiteUnlistedCoworldRouteImport } from './routes/_site.unlisted.$coworld'
import { Route as SiteWikiIndexRouteImport } from './routes/_site.wiki.index'
import { Route as SiteWikiSplatRouteImport } from './routes/_site.wiki.$'
import { Route as WorkspaceIdeNextIndexRouteImport } from './routes/_workspace.ide-next.index'
import { Route as OfficeUnlistedOfficeBeltholderRouteImport } from './routes/_office.unlisted.office.beltholder'
import { Route as OfficeUnlistedOfficeCampaignBoardRouteImport } from './routes/_office.unlisted.office.campaign-board'
import { Route as OfficeUnlistedOfficeCoworldGrowthRouteImport } from './routes/_office.unlisted.office.coworld-growth'
import { Route as SiteCoworldLeagueIndexRouteImport } from './routes/_site.$coworld.$league.index'
import { Route as SiteCoworldLeaguePlayRouteImport } from './routes/_site.$coworld.$league.play'
import { Route as SiteCoworldLeaguePreviewRouteImport } from './routes/_site.$coworld.$league.preview'
import { Route as SiteCoworldLeagueStartRouteImport } from './routes/_site.$coworld.$league.start'
import { Route as SiteCoworldLeagueSubmitRouteImport } from './routes/_site.$coworld.$league.submit'
import { Route as SiteCoworldForumIndexRouteImport } from './routes/_site.$coworld.forum.index'
import { Route as SiteCoworldForumPostIdRouteImport } from './routes/_site.$coworld.forum.$postId'
import { Route as SiteCoworldPlayActivityRouteImport } from './routes/_site.$coworld.play_.activity'
import { Route as SiteCoworldPlayEpisodesRouteImport } from './routes/_site.$coworld.play_.episodes'
import { Route as SiteCoworldPlayRequestsRouteImport } from './routes/_site.$coworld.play_.requests'
import { Route as SiteCoworldPreviewEditRouteImport } from './routes/_site.$coworld.preview_.edit'
import { Route as SiteCoworldWikiIndexRouteImport } from './routes/_site.$coworld.wiki.index'
import { Route as SiteCoworldWikiSplatRouteImport } from './routes/_site.$coworld.wiki.$'
import { Route as SiteCoworldEpisodesEpisodeIdRouteImport } from './routes/_site.$coworld_.episodes.$episodeId'
import { Route as SiteCoworldLobbiesLobbyIdRouteImport } from './routes/_site.$coworld_.lobbies.$lobbyId'
import { Route as SiteCoworldPlaySessionsSessionIdRouteImport } from './routes/_site.$coworld_.play-sessions.$sessionId'
import { Route as SiteCoworldReportsReportSlugRouteImport } from './routes/_site.$coworld_.reports.$reportSlug'
import { Route as SiteCoworldsNameIndexRouteImport } from './routes/_site.coworlds.$name.index'
import { Route as SiteCoworldsNameManageRouteImport } from './routes/_site.coworlds.$name.manage'
import { Route as SiteCoworldsNameRunsRouteImport } from './routes/_site.coworlds.$name.runs'
import { Route as SiteEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.episode-requests.$requestId.watch'
import { Route as SiteLeaguesLeagueIdSettingsRouteImport } from './routes/_site.leagues.$leagueId.settings'
import { Route as SitePoliciesVersionsPolicyVersionIdRouteImport } from './routes/_site.policies.versions.$policyVersionId'
import { Route as SiteUnlistedCoworldIndexRouteImport } from './routes/_site.unlisted.$coworld.index'
import { Route as SiteUnlistedCoworldLeagueRouteImport } from './routes/_site.unlisted.$coworld.$league'
import { Route as SiteUnlistedCoworldDeskRouteImport } from './routes/_site.unlisted.$coworld.desk'
import { Route as SiteUnlistedCoworldPlayRouteImport } from './routes/_site.unlisted.$coworld.play'
import { Route as SiteUnlistedCoworldPreviewRouteImport } from './routes/_site.unlisted.$coworld.preview'
import { Route as SiteUnlistedCoworldSearchRouteImport } from './routes/_site.unlisted.$coworld.search'
import { Route as SiteUnlistedCoworldStartRouteImport } from './routes/_site.unlisted.$coworld.start'
import { Route as SiteUnlistedCoworldSubmitRouteImport } from './routes/_site.unlisted.$coworld.submit'
import { Route as WorkspaceIdeNextSSessionIdRouteImport } from './routes/_workspace.ide-next.s.$sessionId'
import { Route as SiteCoworldLeaguePlayActivityRouteImport } from './routes/_site.$coworld.$league.play_.activity'
import { Route as SiteCoworldLeaguePlayEpisodesRouteImport } from './routes/_site.$coworld.$league.play_.episodes'
import { Route as SiteCoworldLeaguePlayRequestsRouteImport } from './routes/_site.$coworld.$league.play_.requests'
import { Route as SiteCoworldEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.$coworld_.episode-requests.$requestId.watch'
import { Route as SiteCoworldEpisodesEpisodeIdReplayRouteImport } from './routes/_site.$coworld_.episodes.$episodeId_.replay'
import { Route as SiteCoworldsNameRunsRequestIdRouteImport } from './routes/_site.coworlds.$name.runs.$requestId'
import { Route as SiteCoworldsNameRunsNewRouteImport } from './routes/_site.coworlds.$name.runs.new'
import { Route as SiteUnlistedCoworldLeagueIndexRouteImport } from './routes/_site.unlisted.$coworld.$league.index'
import { Route as SiteUnlistedCoworldLeaguePlayRouteImport } from './routes/_site.unlisted.$coworld.$league.play'
import { Route as SiteUnlistedCoworldLeaguePreviewRouteImport } from './routes/_site.unlisted.$coworld.$league.preview'
import { Route as SiteUnlistedCoworldLeagueStartRouteImport } from './routes/_site.unlisted.$coworld.$league.start'
import { Route as SiteUnlistedCoworldLeagueSubmitRouteImport } from './routes/_site.unlisted.$coworld.$league.submit'
import { Route as SiteUnlistedCoworldForumIndexRouteImport } from './routes/_site.unlisted.$coworld.forum.index'
import { Route as SiteUnlistedCoworldForumPostIdRouteImport } from './routes/_site.unlisted.$coworld.forum.$postId'
import { Route as SiteUnlistedCoworldPlayActivityRouteImport } from './routes/_site.unlisted.$coworld.play_.activity'
import { Route as SiteUnlistedCoworldPlayEpisodesRouteImport } from './routes/_site.unlisted.$coworld.play_.episodes'
import { Route as SiteUnlistedCoworldPlayRequestsRouteImport } from './routes/_site.unlisted.$coworld.play_.requests'
import { Route as SiteUnlistedCoworldPreviewEditRouteImport } from './routes/_site.unlisted.$coworld.preview_.edit'
import { Route as SiteUnlistedCoworldWikiIndexRouteImport } from './routes/_site.unlisted.$coworld.wiki.index'
import { Route as SiteUnlistedCoworldWikiSplatRouteImport } from './routes/_site.unlisted.$coworld.wiki.$'
import { Route as SiteUnlistedCoworldEpisodesEpisodeIdRouteImport } from './routes/_site.unlisted.$coworld_.episodes.$episodeId'
import { Route as SiteUnlistedCoworldLobbiesLobbyIdRouteImport } from './routes/_site.unlisted.$coworld_.lobbies.$lobbyId'
import { Route as SiteUnlistedCoworldPlaySessionsSessionIdRouteImport } from './routes/_site.unlisted.$coworld_.play-sessions.$sessionId'
import { Route as SiteUnlistedCoworldReportsReportSlugRouteImport } from './routes/_site.unlisted.$coworld_.reports.$reportSlug'
import { Route as SiteUnlistedCoworldLeaguePlayActivityRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.activity'
import { Route as SiteUnlistedCoworldLeaguePlayEpisodesRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.episodes'
import { Route as SiteUnlistedCoworldLeaguePlayRequestsRouteImport } from './routes/_site.unlisted.$coworld.$league.play_.requests'
import { Route as SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRouteImport } from './routes/_site.unlisted.$coworld_.episode-requests.$requestId.watch'
import { Route as SiteUnlistedCoworldEpisodesEpisodeIdReplayRouteImport } from './routes/_site.unlisted.$coworld_.episodes.$episodeId_.replay'

const OfficeRoute = OfficeRouteImport.update({
            id: '/_office',getParentRoute: () => rootRouteImport
          })
const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const WorkspaceRoute = WorkspaceRouteImport.update({
            id: '/_workspace',getParentRoute: () => rootRouteImport
          })
const SiteCoworldRoute = SiteCoworldRouteImport.update({
            id: '/$coworld',path: '/$coworld',getParentRoute: () => SiteRoute
          })
const SiteAccountRoute = SiteAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => SiteRoute
          })
const SiteBrowseRoute = SiteBrowseRouteImport.update({
            id: '/browse',path: '/browse',getParentRoute: () => SiteRoute
          })
const SiteCompleteProfileRoute = SiteCompleteProfileRouteImport.update({
            id: '/complete-profile',path: '/complete-profile',getParentRoute: () => SiteRoute
          })
const SiteCoworldsRoute = SiteCoworldsRouteImport.update({
            id: '/coworlds',path: '/coworlds',getParentRoute: () => SiteRoute
          })
const SiteGetStartedRoute = SiteGetStartedRouteImport.update({
            id: '/get-started',path: '/get-started',getParentRoute: () => SiteRoute
          })
const SitePoliciesRoute = SitePoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => SiteRoute
          })
const SiteSearchRoute = SiteSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => SiteRoute
          })
const SiteSignInRoute = SiteSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => SiteRoute
          })
const SiteWatchRoute = SiteWatchRouteImport.update({
            id: '/watch',path: '/watch',getParentRoute: () => SiteRoute
          })
const WorkspaceIdeNextRoute = WorkspaceIdeNextRouteImport.update({
            id: '/ide-next',path: '/ide-next',getParentRoute: () => WorkspaceRoute
          })
const SiteCoworldIndexRoute = SiteCoworldIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldLeagueRoute = SiteCoworldLeagueRouteImport.update({
            id: '/$league',path: '/$league',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldDeskRoute = SiteCoworldDeskRouteImport.update({
            id: '/desk',path: '/desk',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPlayRoute = SiteCoworldPlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPreviewRoute = SiteCoworldPreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldSearchRoute = SiteCoworldSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldStartRoute = SiteCoworldStartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldSubmitRoute = SiteCoworldSubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => SiteCoworldRoute
          })
const SiteAccountIndexRoute = SiteAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteAccountRoute
          })
const SiteAccountAdvancedRoute = SiteAccountAdvancedRouteImport.update({
            id: '/advanced',path: '/advanced',getParentRoute: () => SiteAccountRoute
          })
const SiteAccountCredentialsRoute = SiteAccountCredentialsRouteImport.update({
            id: '/credentials',path: '/credentials',getParentRoute: () => SiteAccountRoute
          })
const SiteCliAuthIndexRoute = SiteCliAuthIndexRouteImport.update({
            id: '/cli-auth/',path: '/cli-auth/',getParentRoute: () => SiteRoute
          })
const SiteCliAuthCompleteRoute = SiteCliAuthCompleteRouteImport.update({
            id: '/cli-auth/complete',path: '/cli-auth/complete',getParentRoute: () => SiteRoute
          })
const SiteCoworldsIndexRoute = SiteCoworldsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteCoworldsRoute
          })
const SiteEpisodesEpisodeIdRoute = SiteEpisodesEpisodeIdRouteImport.update({
            id: '/episodes/$episodeId',path: '/episodes/$episodeId',getParentRoute: () => SiteRoute
          })
const SiteExperienceRequestsRequestIdRoute = SiteExperienceRequestsRequestIdRouteImport.update({
            id: '/experience-requests/$requestId',path: '/experience-requests/$requestId',getParentRoute: () => SiteRoute
          })
const SiteForumIndexRoute = SiteForumIndexRouteImport.update({
            id: '/forum/',path: '/forum/',getParentRoute: () => SiteRoute
          })
const SiteForumPostIdRoute = SiteForumPostIdRouteImport.update({
            id: '/forum/$postId',path: '/forum/$postId',getParentRoute: () => SiteRoute
          })
const SiteGithubConnectRoute = SiteGithubConnectRouteImport.update({
            id: '/github/connect',path: '/github/connect',getParentRoute: () => SiteRoute
          })
const SiteLobbiesLobbyIdRoute = SiteLobbiesLobbyIdRouteImport.update({
            id: '/lobbies/$lobbyId',path: '/lobbies/$lobbyId',getParentRoute: () => SiteRoute
          })
const SitePlaySessionsSessionIdRoute = SitePlaySessionsSessionIdRouteImport.update({
            id: '/play-sessions/$sessionId',path: '/play-sessions/$sessionId',getParentRoute: () => SiteRoute
          })
const SitePlayIndexRoute = SitePlayIndexRouteImport.update({
            id: '/play/',path: '/play/',getParentRoute: () => SiteRoute
          })
const SitePlaySplatRoute = SitePlaySplatRouteImport.update({
            id: '/play_/$',path: '/play/$',getParentRoute: () => SiteRoute
          })
const SitePlayersPlayerIdRoute = SitePlayersPlayerIdRouteImport.update({
            id: '/players/$playerId',path: '/players/$playerId',getParentRoute: () => SiteRoute
          })
const SitePoliciesIndexRoute = SitePoliciesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SitePoliciesRoute
          })
const SitePoliciesPolicyIdRoute = SitePoliciesPolicyIdRouteImport.update({
            id: '/$policyId',path: '/$policyId',getParentRoute: () => SitePoliciesRoute
          })
const SitePreviewSplatRoute = SitePreviewSplatRouteImport.update({
            id: '/preview/$',path: '/preview/$',getParentRoute: () => SiteRoute
          })
const SiteReplaysCoworldIdRoute = SiteReplaysCoworldIdRouteImport.update({
            id: '/replays/$coworldId',path: '/replays/$coworldId',getParentRoute: () => SiteRoute
          })
const SiteTournamentsTournamentIdRoute = SiteTournamentsTournamentIdRouteImport.update({
            id: '/tournaments/$tournamentId',path: '/tournaments/$tournamentId',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldRoute = SiteUnlistedCoworldRouteImport.update({
            id: '/unlisted/$coworld',path: '/unlisted/$coworld',getParentRoute: () => SiteRoute
          })
const SiteWikiIndexRoute = SiteWikiIndexRouteImport.update({
            id: '/wiki/',path: '/wiki/',getParentRoute: () => SiteRoute
          })
const SiteWikiSplatRoute = SiteWikiSplatRouteImport.update({
            id: '/wiki/$',path: '/wiki/$',getParentRoute: () => SiteRoute
          })
const WorkspaceIdeNextIndexRoute = WorkspaceIdeNextIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WorkspaceIdeNextRoute
          })
const OfficeUnlistedOfficeBeltholderRoute = OfficeUnlistedOfficeBeltholderRouteImport.update({
            id: '/unlisted/office/beltholder',path: '/unlisted/office/beltholder',getParentRoute: () => OfficeRoute
          })
const OfficeUnlistedOfficeCampaignBoardRoute = OfficeUnlistedOfficeCampaignBoardRouteImport.update({
            id: '/unlisted/office/campaign-board',path: '/unlisted/office/campaign-board',getParentRoute: () => OfficeRoute
          })
const OfficeUnlistedOfficeCoworldGrowthRoute = OfficeUnlistedOfficeCoworldGrowthRouteImport.update({
            id: '/unlisted/office/coworld-growth',path: '/unlisted/office/coworld-growth',getParentRoute: () => OfficeRoute
          })
const SiteCoworldLeagueIndexRoute = SiteCoworldLeagueIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeaguePlayRoute = SiteCoworldLeaguePlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeaguePreviewRoute = SiteCoworldLeaguePreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeagueStartRoute = SiteCoworldLeagueStartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeagueSubmitRoute = SiteCoworldLeagueSubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldForumIndexRoute = SiteCoworldForumIndexRouteImport.update({
            id: '/forum/',path: '/forum/',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldForumPostIdRoute = SiteCoworldForumPostIdRouteImport.update({
            id: '/forum/$postId',path: '/forum/$postId',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPlayActivityRoute = SiteCoworldPlayActivityRouteImport.update({
            id: '/play_/activity',path: '/play/activity',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPlayEpisodesRoute = SiteCoworldPlayEpisodesRouteImport.update({
            id: '/play_/episodes',path: '/play/episodes',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPlayRequestsRoute = SiteCoworldPlayRequestsRouteImport.update({
            id: '/play_/requests',path: '/play/requests',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldPreviewEditRoute = SiteCoworldPreviewEditRouteImport.update({
            id: '/preview_/edit',path: '/preview/edit',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldWikiIndexRoute = SiteCoworldWikiIndexRouteImport.update({
            id: '/wiki/',path: '/wiki/',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldWikiSplatRoute = SiteCoworldWikiSplatRouteImport.update({
            id: '/wiki/$',path: '/wiki/$',getParentRoute: () => SiteCoworldRoute
          })
const SiteCoworldEpisodesEpisodeIdRoute = SiteCoworldEpisodesEpisodeIdRouteImport.update({
            id: '/$coworld_/episodes/$episodeId',path: '/$coworld/episodes/$episodeId',getParentRoute: () => SiteRoute
          })
const SiteCoworldLobbiesLobbyIdRoute = SiteCoworldLobbiesLobbyIdRouteImport.update({
            id: '/$coworld_/lobbies/$lobbyId',path: '/$coworld/lobbies/$lobbyId',getParentRoute: () => SiteRoute
          })
const SiteCoworldPlaySessionsSessionIdRoute = SiteCoworldPlaySessionsSessionIdRouteImport.update({
            id: '/$coworld_/play-sessions/$sessionId',path: '/$coworld/play-sessions/$sessionId',getParentRoute: () => SiteRoute
          })
const SiteCoworldReportsReportSlugRoute = SiteCoworldReportsReportSlugRouteImport.update({
            id: '/$coworld_/reports/$reportSlug',path: '/$coworld/reports/$reportSlug',getParentRoute: () => SiteRoute
          })
const SiteCoworldsNameIndexRoute = SiteCoworldsNameIndexRouteImport.update({
            id: '/$name/',path: '/$name/',getParentRoute: () => SiteCoworldsRoute
          })
const SiteCoworldsNameManageRoute = SiteCoworldsNameManageRouteImport.update({
            id: '/$name/manage',path: '/$name/manage',getParentRoute: () => SiteCoworldsRoute
          })
const SiteCoworldsNameRunsRoute = SiteCoworldsNameRunsRouteImport.update({
            id: '/$name/runs',path: '/$name/runs',getParentRoute: () => SiteCoworldsRoute
          })
const SiteEpisodeRequestsRequestIdWatchRoute = SiteEpisodeRequestsRequestIdWatchRouteImport.update({
            id: '/episode-requests/$requestId/watch',path: '/episode-requests/$requestId/watch',getParentRoute: () => SiteRoute
          })
const SiteLeaguesLeagueIdSettingsRoute = SiteLeaguesLeagueIdSettingsRouteImport.update({
            id: '/leagues/$leagueId/settings',path: '/leagues/$leagueId/settings',getParentRoute: () => SiteRoute
          })
const SitePoliciesVersionsPolicyVersionIdRoute = SitePoliciesVersionsPolicyVersionIdRouteImport.update({
            id: '/versions/$policyVersionId',path: '/versions/$policyVersionId',getParentRoute: () => SitePoliciesRoute
          })
const SiteUnlistedCoworldIndexRoute = SiteUnlistedCoworldIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldLeagueRoute = SiteUnlistedCoworldLeagueRouteImport.update({
            id: '/$league',path: '/$league',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldDeskRoute = SiteUnlistedCoworldDeskRouteImport.update({
            id: '/desk',path: '/desk',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPlayRoute = SiteUnlistedCoworldPlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPreviewRoute = SiteUnlistedCoworldPreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldSearchRoute = SiteUnlistedCoworldSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldStartRoute = SiteUnlistedCoworldStartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldSubmitRoute = SiteUnlistedCoworldSubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const WorkspaceIdeNextSSessionIdRoute = WorkspaceIdeNextSSessionIdRouteImport.update({
            id: '/s/$sessionId',path: '/s/$sessionId',getParentRoute: () => WorkspaceIdeNextRoute
          })
const SiteCoworldLeaguePlayActivityRoute = SiteCoworldLeaguePlayActivityRouteImport.update({
            id: '/play_/activity',path: '/play/activity',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeaguePlayEpisodesRoute = SiteCoworldLeaguePlayEpisodesRouteImport.update({
            id: '/play_/episodes',path: '/play/episodes',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldLeaguePlayRequestsRoute = SiteCoworldLeaguePlayRequestsRouteImport.update({
            id: '/play_/requests',path: '/play/requests',getParentRoute: () => SiteCoworldLeagueRoute
          })
const SiteCoworldEpisodeRequestsRequestIdWatchRoute = SiteCoworldEpisodeRequestsRequestIdWatchRouteImport.update({
            id: '/$coworld_/episode-requests/$requestId/watch',path: '/$coworld/episode-requests/$requestId/watch',getParentRoute: () => SiteRoute
          })
const SiteCoworldEpisodesEpisodeIdReplayRoute = SiteCoworldEpisodesEpisodeIdReplayRouteImport.update({
            id: '/$coworld_/episodes/$episodeId_/replay',path: '/$coworld/episodes/$episodeId/replay',getParentRoute: () => SiteRoute
          })
const SiteCoworldsNameRunsRequestIdRoute = SiteCoworldsNameRunsRequestIdRouteImport.update({
            id: '/$requestId',path: '/$requestId',getParentRoute: () => SiteCoworldsNameRunsRoute
          })
const SiteCoworldsNameRunsNewRoute = SiteCoworldsNameRunsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => SiteCoworldsNameRunsRoute
          })
const SiteUnlistedCoworldLeagueIndexRoute = SiteUnlistedCoworldLeagueIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeaguePlayRoute = SiteUnlistedCoworldLeaguePlayRouteImport.update({
            id: '/play',path: '/play',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeaguePreviewRoute = SiteUnlistedCoworldLeaguePreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeagueStartRoute = SiteUnlistedCoworldLeagueStartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeagueSubmitRoute = SiteUnlistedCoworldLeagueSubmitRouteImport.update({
            id: '/submit',path: '/submit',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldForumIndexRoute = SiteUnlistedCoworldForumIndexRouteImport.update({
            id: '/forum/',path: '/forum/',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldForumPostIdRoute = SiteUnlistedCoworldForumPostIdRouteImport.update({
            id: '/forum/$postId',path: '/forum/$postId',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPlayActivityRoute = SiteUnlistedCoworldPlayActivityRouteImport.update({
            id: '/play_/activity',path: '/play/activity',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPlayEpisodesRoute = SiteUnlistedCoworldPlayEpisodesRouteImport.update({
            id: '/play_/episodes',path: '/play/episodes',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPlayRequestsRoute = SiteUnlistedCoworldPlayRequestsRouteImport.update({
            id: '/play_/requests',path: '/play/requests',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldPreviewEditRoute = SiteUnlistedCoworldPreviewEditRouteImport.update({
            id: '/preview_/edit',path: '/preview/edit',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldWikiIndexRoute = SiteUnlistedCoworldWikiIndexRouteImport.update({
            id: '/wiki/',path: '/wiki/',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldWikiSplatRoute = SiteUnlistedCoworldWikiSplatRouteImport.update({
            id: '/wiki/$',path: '/wiki/$',getParentRoute: () => SiteUnlistedCoworldRoute
          })
const SiteUnlistedCoworldEpisodesEpisodeIdRoute = SiteUnlistedCoworldEpisodesEpisodeIdRouteImport.update({
            id: '/unlisted/$coworld_/episodes/$episodeId',path: '/unlisted/$coworld/episodes/$episodeId',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldLobbiesLobbyIdRoute = SiteUnlistedCoworldLobbiesLobbyIdRouteImport.update({
            id: '/unlisted/$coworld_/lobbies/$lobbyId',path: '/unlisted/$coworld/lobbies/$lobbyId',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldPlaySessionsSessionIdRoute = SiteUnlistedCoworldPlaySessionsSessionIdRouteImport.update({
            id: '/unlisted/$coworld_/play-sessions/$sessionId',path: '/unlisted/$coworld/play-sessions/$sessionId',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldReportsReportSlugRoute = SiteUnlistedCoworldReportsReportSlugRouteImport.update({
            id: '/unlisted/$coworld_/reports/$reportSlug',path: '/unlisted/$coworld/reports/$reportSlug',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldLeaguePlayActivityRoute = SiteUnlistedCoworldLeaguePlayActivityRouteImport.update({
            id: '/play_/activity',path: '/play/activity',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeaguePlayEpisodesRoute = SiteUnlistedCoworldLeaguePlayEpisodesRouteImport.update({
            id: '/play_/episodes',path: '/play/episodes',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldLeaguePlayRequestsRoute = SiteUnlistedCoworldLeaguePlayRequestsRouteImport.update({
            id: '/play_/requests',path: '/play/requests',getParentRoute: () => SiteUnlistedCoworldLeagueRoute
          })
const SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute = SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRouteImport.update({
            id: '/unlisted/$coworld_/episode-requests/$requestId/watch',path: '/unlisted/$coworld/episode-requests/$requestId/watch',getParentRoute: () => SiteRoute
          })
const SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute = SiteUnlistedCoworldEpisodesEpisodeIdReplayRouteImport.update({
            id: '/unlisted/$coworld_/episodes/$episodeId_/replay',path: '/unlisted/$coworld/episodes/$episodeId/replay',getParentRoute: () => SiteRoute
          })





const OfficeRouteChildren = {
  OfficeUnlistedOfficeBeltholderRoute: OfficeUnlistedOfficeBeltholderRoute,OfficeUnlistedOfficeCampaignBoardRoute: OfficeUnlistedOfficeCampaignBoardRoute,OfficeUnlistedOfficeCoworldGrowthRoute: OfficeUnlistedOfficeCoworldGrowthRoute
}

const OfficeRouteWithChildren = OfficeRoute._addFileChildren(OfficeRouteChildren)




const SiteCoworldLeagueRouteChildren = {
  SiteCoworldLeaguePlayRoute: SiteCoworldLeaguePlayRoute,SiteCoworldLeaguePreviewRoute: SiteCoworldLeaguePreviewRoute,SiteCoworldLeagueStartRoute: SiteCoworldLeagueStartRoute,SiteCoworldLeagueSubmitRoute: SiteCoworldLeagueSubmitRoute,SiteCoworldLeagueIndexRoute: SiteCoworldLeagueIndexRoute,SiteCoworldLeaguePlayActivityRoute: SiteCoworldLeaguePlayActivityRoute,SiteCoworldLeaguePlayEpisodesRoute: SiteCoworldLeaguePlayEpisodesRoute,SiteCoworldLeaguePlayRequestsRoute: SiteCoworldLeaguePlayRequestsRoute
}

const SiteCoworldLeagueRouteWithChildren = SiteCoworldLeagueRoute._addFileChildren(SiteCoworldLeagueRouteChildren)



const SiteCoworldRouteChildren = {
  SiteCoworldLeagueRoute: SiteCoworldLeagueRouteWithChildren,SiteCoworldDeskRoute: SiteCoworldDeskRoute,SiteCoworldPlayRoute: SiteCoworldPlayRoute,SiteCoworldPreviewRoute: SiteCoworldPreviewRoute,SiteCoworldSearchRoute: SiteCoworldSearchRoute,SiteCoworldStartRoute: SiteCoworldStartRoute,SiteCoworldSubmitRoute: SiteCoworldSubmitRoute,SiteCoworldIndexRoute: SiteCoworldIndexRoute,SiteCoworldForumPostIdRoute: SiteCoworldForumPostIdRoute,SiteCoworldPlayActivityRoute: SiteCoworldPlayActivityRoute,SiteCoworldPlayEpisodesRoute: SiteCoworldPlayEpisodesRoute,SiteCoworldPlayRequestsRoute: SiteCoworldPlayRequestsRoute,SiteCoworldPreviewEditRoute: SiteCoworldPreviewEditRoute,SiteCoworldWikiSplatRoute: SiteCoworldWikiSplatRoute,SiteCoworldForumIndexRoute: SiteCoworldForumIndexRoute,SiteCoworldWikiIndexRoute: SiteCoworldWikiIndexRoute
}

const SiteCoworldRouteWithChildren = SiteCoworldRoute._addFileChildren(SiteCoworldRouteChildren)




const SiteAccountRouteChildren = {
  SiteAccountAdvancedRoute: SiteAccountAdvancedRoute,SiteAccountCredentialsRoute: SiteAccountCredentialsRoute,SiteAccountIndexRoute: SiteAccountIndexRoute
}

const SiteAccountRouteWithChildren = SiteAccountRoute._addFileChildren(SiteAccountRouteChildren)




const SiteCoworldsNameRunsRouteChildren = {
  SiteCoworldsNameRunsRequestIdRoute: SiteCoworldsNameRunsRequestIdRoute,SiteCoworldsNameRunsNewRoute: SiteCoworldsNameRunsNewRoute
}

const SiteCoworldsNameRunsRouteWithChildren = SiteCoworldsNameRunsRoute._addFileChildren(SiteCoworldsNameRunsRouteChildren)



const SiteCoworldsRouteChildren = {
  SiteCoworldsIndexRoute: SiteCoworldsIndexRoute,SiteCoworldsNameManageRoute: SiteCoworldsNameManageRoute,SiteCoworldsNameRunsRoute: SiteCoworldsNameRunsRouteWithChildren,SiteCoworldsNameIndexRoute: SiteCoworldsNameIndexRoute
}

const SiteCoworldsRouteWithChildren = SiteCoworldsRoute._addFileChildren(SiteCoworldsRouteChildren)




const SitePoliciesRouteChildren = {
  SitePoliciesPolicyIdRoute: SitePoliciesPolicyIdRoute,SitePoliciesIndexRoute: SitePoliciesIndexRoute,SitePoliciesVersionsPolicyVersionIdRoute: SitePoliciesVersionsPolicyVersionIdRoute
}

const SitePoliciesRouteWithChildren = SitePoliciesRoute._addFileChildren(SitePoliciesRouteChildren)




const SiteUnlistedCoworldLeagueRouteChildren = {
  SiteUnlistedCoworldLeaguePlayRoute: SiteUnlistedCoworldLeaguePlayRoute,SiteUnlistedCoworldLeaguePreviewRoute: SiteUnlistedCoworldLeaguePreviewRoute,SiteUnlistedCoworldLeagueStartRoute: SiteUnlistedCoworldLeagueStartRoute,SiteUnlistedCoworldLeagueSubmitRoute: SiteUnlistedCoworldLeagueSubmitRoute,SiteUnlistedCoworldLeagueIndexRoute: SiteUnlistedCoworldLeagueIndexRoute,SiteUnlistedCoworldLeaguePlayActivityRoute: SiteUnlistedCoworldLeaguePlayActivityRoute,SiteUnlistedCoworldLeaguePlayEpisodesRoute: SiteUnlistedCoworldLeaguePlayEpisodesRoute,SiteUnlistedCoworldLeaguePlayRequestsRoute: SiteUnlistedCoworldLeaguePlayRequestsRoute
}

const SiteUnlistedCoworldLeagueRouteWithChildren = SiteUnlistedCoworldLeagueRoute._addFileChildren(SiteUnlistedCoworldLeagueRouteChildren)



const SiteUnlistedCoworldRouteChildren = {
  SiteUnlistedCoworldLeagueRoute: SiteUnlistedCoworldLeagueRouteWithChildren,SiteUnlistedCoworldDeskRoute: SiteUnlistedCoworldDeskRoute,SiteUnlistedCoworldPlayRoute: SiteUnlistedCoworldPlayRoute,SiteUnlistedCoworldPreviewRoute: SiteUnlistedCoworldPreviewRoute,SiteUnlistedCoworldSearchRoute: SiteUnlistedCoworldSearchRoute,SiteUnlistedCoworldStartRoute: SiteUnlistedCoworldStartRoute,SiteUnlistedCoworldSubmitRoute: SiteUnlistedCoworldSubmitRoute,SiteUnlistedCoworldIndexRoute: SiteUnlistedCoworldIndexRoute,SiteUnlistedCoworldForumPostIdRoute: SiteUnlistedCoworldForumPostIdRoute,SiteUnlistedCoworldPlayActivityRoute: SiteUnlistedCoworldPlayActivityRoute,SiteUnlistedCoworldPlayEpisodesRoute: SiteUnlistedCoworldPlayEpisodesRoute,SiteUnlistedCoworldPlayRequestsRoute: SiteUnlistedCoworldPlayRequestsRoute,SiteUnlistedCoworldPreviewEditRoute: SiteUnlistedCoworldPreviewEditRoute,SiteUnlistedCoworldWikiSplatRoute: SiteUnlistedCoworldWikiSplatRoute,SiteUnlistedCoworldForumIndexRoute: SiteUnlistedCoworldForumIndexRoute,SiteUnlistedCoworldWikiIndexRoute: SiteUnlistedCoworldWikiIndexRoute
}

const SiteUnlistedCoworldRouteWithChildren = SiteUnlistedCoworldRoute._addFileChildren(SiteUnlistedCoworldRouteChildren)



const SiteRouteChildren = {
  SiteCoworldRoute: SiteCoworldRouteWithChildren,SiteAccountRoute: SiteAccountRouteWithChildren,SiteBrowseRoute: SiteBrowseRoute,SiteCompleteProfileRoute: SiteCompleteProfileRoute,SiteCoworldsRoute: SiteCoworldsRouteWithChildren,SiteGetStartedRoute: SiteGetStartedRoute,SitePoliciesRoute: SitePoliciesRouteWithChildren,SiteSearchRoute: SiteSearchRoute,SiteSignInRoute: SiteSignInRoute,SiteWatchRoute: SiteWatchRoute,SiteCliAuthCompleteRoute: SiteCliAuthCompleteRoute,SiteEpisodesEpisodeIdRoute: SiteEpisodesEpisodeIdRoute,SiteExperienceRequestsRequestIdRoute: SiteExperienceRequestsRequestIdRoute,SiteForumPostIdRoute: SiteForumPostIdRoute,SiteGithubConnectRoute: SiteGithubConnectRoute,SiteLobbiesLobbyIdRoute: SiteLobbiesLobbyIdRoute,SitePlaySessionsSessionIdRoute: SitePlaySessionsSessionIdRoute,SitePlaySplatRoute: SitePlaySplatRoute,SitePlayersPlayerIdRoute: SitePlayersPlayerIdRoute,SitePreviewSplatRoute: SitePreviewSplatRoute,SiteReplaysCoworldIdRoute: SiteReplaysCoworldIdRoute,SiteTournamentsTournamentIdRoute: SiteTournamentsTournamentIdRoute,SiteUnlistedCoworldRoute: SiteUnlistedCoworldRouteWithChildren,SiteWikiSplatRoute: SiteWikiSplatRoute,SiteCliAuthIndexRoute: SiteCliAuthIndexRoute,SiteForumIndexRoute: SiteForumIndexRoute,SitePlayIndexRoute: SitePlayIndexRoute,SiteWikiIndexRoute: SiteWikiIndexRoute,SiteCoworldEpisodesEpisodeIdRoute: SiteCoworldEpisodesEpisodeIdRoute,SiteCoworldLobbiesLobbyIdRoute: SiteCoworldLobbiesLobbyIdRoute,SiteCoworldPlaySessionsSessionIdRoute: SiteCoworldPlaySessionsSessionIdRoute,SiteCoworldReportsReportSlugRoute: SiteCoworldReportsReportSlugRoute,SiteEpisodeRequestsRequestIdWatchRoute: SiteEpisodeRequestsRequestIdWatchRoute,SiteLeaguesLeagueIdSettingsRoute: SiteLeaguesLeagueIdSettingsRoute,SiteCoworldEpisodeRequestsRequestIdWatchRoute: SiteCoworldEpisodeRequestsRequestIdWatchRoute,SiteCoworldEpisodesEpisodeIdReplayRoute: SiteCoworldEpisodesEpisodeIdReplayRoute,SiteUnlistedCoworldEpisodesEpisodeIdRoute: SiteUnlistedCoworldEpisodesEpisodeIdRoute,SiteUnlistedCoworldLobbiesLobbyIdRoute: SiteUnlistedCoworldLobbiesLobbyIdRoute,SiteUnlistedCoworldPlaySessionsSessionIdRoute: SiteUnlistedCoworldPlaySessionsSessionIdRoute,SiteUnlistedCoworldReportsReportSlugRoute: SiteUnlistedCoworldReportsReportSlugRoute,SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute: SiteUnlistedCoworldEpisodeRequestsRequestIdWatchRoute,SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute: SiteUnlistedCoworldEpisodesEpisodeIdReplayRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)




const WorkspaceIdeNextRouteChildren = {
  WorkspaceIdeNextIndexRoute: WorkspaceIdeNextIndexRoute,WorkspaceIdeNextSSessionIdRoute: WorkspaceIdeNextSSessionIdRoute
}

const WorkspaceIdeNextRouteWithChildren = WorkspaceIdeNextRoute._addFileChildren(WorkspaceIdeNextRouteChildren)



const WorkspaceRouteChildren = {
  WorkspaceIdeNextRoute: WorkspaceIdeNextRouteWithChildren
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(WorkspaceRouteChildren)

const rootRouteChildren = {
  OfficeRoute: OfficeRouteWithChildren,SiteRoute: SiteRouteWithChildren,WorkspaceRoute: WorkspaceRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)